import { queryClient } from "@app/config/queryClient";
import { router } from "@app/config/router";
import { GlobalErrorFallback } from "@app/ui/GlobalErrorFallback";
import { OverlayProvider } from "@base/model/hooks/useOverlay";
// import { NetworkStatusBanner } from "@base/ui/NetworkStatusBanner";
import { AppUpdateBanner } from "@base/ui/AppUpdateBanner";
import { BuildVersionBadge } from "@base/ui/BuildVersionBadge";
import { InstallPromptBanner } from "@base/ui/InstallPromptBanner";
import { PushNotificationBridge } from "@base/ui/PushNotificationBridge";
import { PwaLaunchBridge } from "@base/ui/PwaLaunchBridge";
import { Toaster } from "@base/ui/Toaster";
import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

export function App() {
  return (
    <Sentry.ErrorBoundary fallback={({ resetError }) => <GlobalErrorFallback resetError={resetError} />}>
      <QueryClientProvider client={queryClient}>
        {/* <NetworkStatusBanner /> */}
        <AppUpdateBanner />
        <InstallPromptBanner />
        <BuildVersionBadge />
        <RouterProvider
          router={router}
          InnerWrap={({ children }) => (
            <OverlayProvider>
              <PushNotificationBridge />
              <PwaLaunchBridge />
              {children}
            </OverlayProvider>
          )}
        />
        <Toaster />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}
